<template>
  <div style="display: contents;">
    <b-row>
      <b-col sm="12" class="d-flex justify-content-end border-bottom pb-2 mb-4">
        <div>
          <button class="btn btn-outline-primary btn-xs " @click="onPrint()" v-b-tooltip.hover :title="$gettext('Print')">
            <b-icon icon="file-earmark-text" /> <translate>Print</translate>
          </button>
          <button class="btn btn-outline-danger btn-xs mx-2" @click="onDownload()" v-b-tooltip.hover title="PDF">
            <b-icon icon="download" /> PDF
          </button>
        </div>
      </b-col>
    </b-row>
    <div  id="printArea">
      <b-row>
        <b-col md="8">
          <h5 class="result-summary"><translate>Booking details</translate></h5>
          <table class="table table-striped border">
              <tr>
                <td><b><translate> Booking date</translate>:</b> {{ getDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
                <td>
                  <b><translate>Total amount</translate>:</b> {{ booking.currency }} {{ bookingTotal  }}
                  <b-icon :icon="collapsed ? 'dash-square': 'plus-square'" variant="dark" scale="1.1" @click="collapsed = !collapsed" class="float-right"/>
                </td>
              </tr>
              <tr>
                <td><b><translate>Booking number</translate>:</b> {{ booking.id}}</td>
                <td>
                  <span v-if="!collapsed">
                    <b><translate>Comision</translate>:</b> {{ booking.currency }} {{ booking.commission }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><b><translate>Booking status</translate>:</b> {{ booking.status}}</td>
                <td>
                  <span v-if="!collapsed">
                    <b v-if="!collapsed"><translate>Total payment</translate>:</b> {{ booking.currency }} {{ bookingTotalDue }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><b><translate>Destination</translate>:</b> {{ booking.destination }}</td>
                <td>
                  <span v-if="!collapsed">
                    <b><translate>Paid</translate>:</b> {{ booking.currency }} {{ booking.paid }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><b><translate>Agent</translate>:</b> {{ booking.user }}</td>
                <td>
                  <span  v-if="!collapsed">
                    <b><translate>Rest payment</translate>:</b> {{ booking.currency }} {{ bookingUnpaid }}
                  </span>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <b><translate>Agency</translate>:</b> {{ userData.companyName }}
                </td>
              </tr>
              <tr v-if="!collapsed">
                <td ><b><translate>Payment schedule</translate>:</b> </td>
                <td>
                  <span v-for="(d,dIndex) in booking.due_dates" :key="'dueDate'+dIndex">{{ booking.currency }} {{ d.amount }} pana la {{ d.date }}<br /></span>
                  <translate>difference up to</translate>: {{ booking.balance_due_date }}
                </td>
              </tr>
          </table>
          <b-card class="p-2" no-body="">
            <b><translate>Agent Notes</translate>:</b>
              <span v-for="(note, index) in booking.notes" :key="index" style="white-space: pre-line;">
                {{note.text}}
              </span>
          </b-card>
        </b-col>
        <b-col md="4" class="my-3 my-md-0">
          <h5 class="result-summary" v-translate>Passengers</h5>
          <table class="table table-striped table-sm border">
            <tbody>
              <tr v-for="(pax, paxIndex) in booking.pax" :key="paxIndex">
                <td><span class="small text-">{{pax.title + ' ' + pax.fname + ' ' + pax.lname}}</span>
                <span class="badge float-right"> {{ pax.ageGroup }} / {{ getDate(pax.bdate) }} </span></td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <hr />
        </b-col>
      </b-row>
      <b-row v-for="item in booking.items" :key="'item' + item.id">
        <b-col>
          <HotelItem :item="item" v-if="item.type === 'hotel'" />
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col sm="12">
        <hr>
      </b-col>
      <b-col>
        <b-button variant="warning" size="sm" class="float-right" @click="$router.push({ name: 'Private/Bookings/Search' })"><b-icon icon="chevron-left" />Back to results</b-button>
      </b-col>
    </b-row>
    <!-- {{ booking.id }} -->
  </div>
</template>

<script>
import moment from 'moment'
import http from 'b2b-common/vue-config/axios'

import { authApiURL } from 'b2b-common/utils'
import { getInvoice, downloadPdf } from 'b2b-common/services/api/document'

import authMixin from 'b2b-common/mixins/auth'
import viewMixin from '../../shared/mixins/search_views'

import HotelItem from './hotel_item_info'

export default {
  name: 'bookingDetails',
  props: ['booking'],
  mixins: [authMixin, viewMixin],
  components: { HotelItem },
  data () {
    return {
      file: null,
      collapsed: false
    }
  },
  computed: {
    bookingTotal () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax)
      return Math.ceil(n * 100) / 100
    },
    bookingTotalDue () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission)
      return Math.ceil(n * 100) / 100
    },
    bookingUnpaid () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission) - parseFloat(this.booking.paid)
      return Math.ceil(n * 100) / 100
    }
  },
  methods: {
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    async onUploadClick () {
      const formData = new FormData()
      formData.append('file', this.file)
      const res = await http.post(authApiURL,
        formData,
        {
          params: {
            action: 'attachBookingFile',
            id: this.booking.id
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      this.booking.attachments.push(res.data)
      return res.data
    },
    async downloadInvoice (invoice) {
      const pdfData = await getInvoice({ booking: this.booking.id, invoice: invoice.id })
      const fileName = 'factura_' + invoice.number + '.pdf'
      downloadPdf({ pdfData, fileName })
    }
  }
}
</script>
